import React from 'react';
import './JsonViewer.css';

class JsonViewer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expandedPaths: new Set()
    };
  }

  togglePath = (path) => {
    this.setState((prevState) => {
      const next = new Set(prevState.expandedPaths);
      if (next.has(path)) {
        next.delete(path);
      } else {
        next.add(path);
      }
      return { expandedPaths: next };
    });
  };

  isPathExpanded = (path) => {
    const { defaultExpanded } = this.props;
    const { expandedPaths } = this.state;
    return expandedPaths.has(path) || (defaultExpanded && expandedPaths.size === 0);
  };

  renderValue = (value, path = '', depth = 0) => {
    const { maxDepth } = this.props;
    const isMaxDepth = maxDepth !== null && depth >= maxDepth;

    if (value === null) {
      return <span className="Json-value Json-value-null">null</span>;
    }

    if (value === undefined) {
      return <span className="Json-value Json-value-undefined">undefined</span>;
    }

    if (typeof value === 'boolean') {
      return (
        <span className="Json-value Json-value-boolean">{value.toString()}</span>
      );
    }

    if (typeof value === 'number') {
      return <span className="Json-value Json-value-number">{value}</span>;
    }

    if (typeof value === 'string') {
      // Try to detect if it's a date string
      const dateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;
      if (dateRegex.test(value)) {
        return (
          <span className="Json-value Json-value-string">
            "<span className="Json-value-date">{value}</span>"
          </span>
        );
      }
      return (
        <span className="Json-value Json-value-string">"{value}"</span>
      );
    }

    if (Array.isArray(value)) {
      if (value.length === 0) {
        return (
          <span>
            <span className="Json-bracket">[</span>
            <span className="Json-bracket">]</span>
          </span>
        );
      }

      const isExpanded = this.isPathExpanded(path);
      const shouldShowContent = isExpanded && !isMaxDepth;

      return (
        <div className="Json-container">
          <span
            className={`Json-toggle ${isExpanded ? 'Json-toggle-expanded' : ''}`}
            onClick={() => !isMaxDepth && this.togglePath(path)}
          >
            {shouldShowContent ? '▼' : '▶'}
          </span>
          <span className="Json-bracket">[</span>
          {shouldShowContent ? (
            <div className="Json-nested">
              {value.map((item, index) => (
                <div key={index} className="Json-item">
                  <span className="Json-index">{index}:</span>
                  {this.renderValue(item, `${path}[${index}]`, depth + 1)}
                  {index < value.length - 1 && (
                    <span className="Json-comma">,</span>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <span className="Json-placeholder">
              {value.length} {value.length === 1 ? 'item' : 'items'}
            </span>
          )}
          <span className="Json-bracket">]</span>
        </div>
      );
    }

    if (typeof value === 'object') {
      const keys = Object.keys(value);
      if (keys.length === 0) {
        return (
          <span>
            <span className="Json-brace">{'{'}</span>
            <span className="Json-brace">{'}'}</span>
          </span>
        );
      }

      const isExpanded = this.isPathExpanded(path);
      const shouldShowContent = isExpanded && !isMaxDepth;

      return (
        <div className="Json-container">
          <span
            className={`Json-toggle ${isExpanded ? 'Json-toggle-expanded' : ''}`}
            onClick={() => !isMaxDepth && this.togglePath(path)}
          >
            {shouldShowContent ? '▼' : '▶'}
          </span>
          <span className="Json-brace">{'{'}</span>
          {shouldShowContent ? (
            <div className="Json-nested">
              {keys.map((key, index) => (
                <div key={key} className="Json-item">
                  <span className="Json-key">"{key}"</span>
                  <span className="Json-colon">:</span>
                  {this.renderValue(value[key], `${path}.${key}`, depth + 1)}
                  {index < keys.length - 1 && (
                    <span className="Json-comma">,</span>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <span className="Json-placeholder">
              {keys.length} {keys.length === 1 ? 'key' : 'keys'}
            </span>
          )}
          <span className="Json-brace">{'}'}</span>
        </div>
      );
    }

    return <span className="Json-value">{String(value)}</span>;
  };

  getParsedData = () => {
    const { data } = this.props;
    if (typeof data === 'string') {
      try {
        return JSON.parse(data);
      } catch (e) {
        return data;
      }
    }
    return data;
  };

  render() {
    const { className = '' } = this.props;
    const parsedData = this.getParsedData();

    return (
      <div className={`Json-viewer ${className}`}>
        {this.renderValue(parsedData, 'root', 0)}
      </div>
    );
  }
}

JsonViewer.defaultProps = {
  defaultExpanded: true,
  maxDepth: null,
  className: ''
};

export default JsonViewer;




// WEBPACK FOOTER //
// ./src/components/basic/JsonViewer.js